export const MAKE_ALERT = 'makeAlert';
